import axios from '@/utils/request';
var Qs = require('qs');

export default {
  // 2020-09-14
  search(params) {
    return axios.get('/inventories-snapshoot', params);
  },
  // 2023-07-07
  productNoSearch(params) {
    return axios.get('/inventories-snapshoot/product-no-search', params);
  },
  // 2021-06-06
  quickPhotoExportExcel(params) {
    return axios.get(
      '/inventories-snapshoot/quick-photo-export-excel?' +
        Qs.stringify(params, { arrayFormat: 'repeat' })
    );
  },
};
